<template>
    <div>
        <CModal
            size="md"
            :centered="true"
            color="white"
            :show.sync="isShownDelete"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Confirmation Delete</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closePopUp()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding: 24px">
                    <CRow class="mt-2 mb-3">
                        <CCol sm="12">
                            <span class="font-weight-bold">Apakah anda yakin ingin menghapus data shift ?</span>
                        </CCol>
                    </CRow>
                    <CRow style="margin-top: 46px;">
                        <CCol sm="12">
                            <CButton @click="closePopUp()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                            <CButton @click="deleteShift()" class="btn btn-edit-submit">
                                <span v-if="loading == false">Ya, Hapus</span>
                                <CSpinner v-else color="default" size="sm"/>
                            </CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</template>

<script>
import Tables from '../../../component/tableShiftNew'
export default {
    components: {
        Tables
    },
    data() {
        return {
            loading: false,
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            isShownDelete: false,
            datas: null,

            // Table
        }
    },
    methods: {
        closePopUp() {
            this.isShownDelete = false
            this.loading = false
            this.datas = null
        },
        deleteShift() {
            this.$emit('goDelete', this.datas)
        },
    },
    watch: {
    },
    mounted() {
    },
}
</script>
<style scoped>
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
</style>